import md5 from "md5";
import { getMonthsArray } from "../";

export const tariffMonthlyRows = (data, taxName, gettext) => {
  const rows = [];

  const taxesData = data?.tariffDetails?.taxes;
  const monthsArray = getMonthsArray(gettext);
  const monthIndex = data?.tariffDetails?.month || 0;
  const selectedMonth = monthsArray[monthIndex].value;

  // if (data?.consumptionEnergyData?.consumptionData[0]?.details?.data[0]?.meter) {
  if (Array.isArray(taxesData) && taxesData.length > 0) {
    taxesData.map((objTaxesData) => {
      const orderNo = objTaxesData?.meteringPointId;

      if (!rows["all"]) {
        rows["all"] = [];
      }

      if (!rows[selectedMonth]) {
        rows[selectedMonth] = [];
      }

      objTaxesData[taxName].map((hourlyData) => {
        const rowIndex = [];
        const id = md5(hourlyData.ts);
        rowIndex["all"] = rows["all"].findIndex((obj) => obj.id === id);
        rowIndex[selectedMonth] = rows[selectedMonth].findIndex(
          (obj) => obj.id === id,
        );
        if (rowIndex["all"] > -1) {
          rows["all"][rowIndex["all"]][orderNo] = hourlyData.tariff;
        } else {
          const row = {
            id: id,
            ts: hourlyData.ts,
          };
          row[orderNo] = hourlyData.tariff;
          rows["all"].push(row);
        }

        if (rowIndex[selectedMonth] > -1) {
          rows[selectedMonth][rowIndex[selectedMonth]][orderNo] =
            hourlyData.tariff;
        } else {
          const row = {
            id: id,
            ts: hourlyData.ts,
          };
          row[orderNo] = hourlyData.tariff;
          rows[selectedMonth].push(row);
        }
        return null;
      });
      return null;
    });
  }

  return rows;
};
